import React from 'react'
import './css/fitnesslogger.css';

export default function FLHeader(props) {
  return (
    <header className="fl__banner">
        <h1 className="fl__title">FitnessLogger</h1>
        <p className="fl__subtitle">{props.subtitle}</p>
    </header>
  )
}